import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Film } from 'lucide-react';

/**
 * Görev 3: AuthGate - Auth yüklenirken beklet
 * 
 * AuthContext'ten auth durumu gelene kadar children'ı render etmez.
 * Bu sayede ilk render'da veri çekimini engeller.
 */
const AuthGate = ({ children }) => {
    const { authStatus, authInitialized } = useAuth();

    // Auth henüz hazır değilse loading göster
    if (!authInitialized || authStatus === 'loading') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
                    <div className="flex items-center justify-center mb-2">
                        <Film className="h-6 w-6 text-purple-600 mr-2" />
                        <p className="text-gray-900 dark:text-white font-semibold text-lg">Removvie</p>
                    </div>
                    <p className="text-gray-600 dark:text-gray-400">Yükleniyor...</p>
                </div>
            </div>
        );
    }

    // Auth hazır, children'ı render et
    return <>{children}</>;
};

export default AuthGate;
